import { c as _c } from "react/compiler-runtime";
type BenefitCard = {
  icon: string;
  iconAlt: string;
  iconWidth: number;
  iconHeight: number;
  title: string;
  desc: string;
};
const ICON_BASE = "/inquiry-landing/benefits";
const CARDS: readonly BenefitCard[] = [{
  icon: `${ICON_BASE}/collect.svg`,
  iconAlt: "통합 리뷰 수집 아이콘",
  iconWidth: 60,
  iconHeight: 58,
  title: "통합 리뷰 수집",
  desc: "흩어진 리뷰를 한곳에 모아 환자가 신뢰할 수 있는 정보를 제공합니다."
}, {
  icon: `${ICON_BASE}/search.svg`,
  iconAlt: "AI 검색에 노출 아이콘",
  iconWidth: 55,
  iconHeight: 58,
  title: "AI 검색에 노출",
  desc: "생성형 AI 답변에 우리 병원 리뷰가 인용되도록 지원합니다."
}, {
  icon: `${ICON_BASE}/patients.svg`,
  iconAlt: "신규 환자 유입 아이콘",
  iconWidth: 50,
  iconHeight: 58,
  title: "신규 환자 유입",
  desc: "환자의 검색이 AI로 이동하는 시대, 새로운 환자 유입 기회를 확보할 수 있습니다."
}, {
  icon: `${ICON_BASE}/hospital.svg`,
  iconAlt: "간편한 병원 등록 아이콘",
  iconWidth: 58,
  iconHeight: 58,
  title: "간편한 병원 등록",
  desc: "복잡한 설정 없이 병원 정보를 등록하고 관리할 수 있습니다."
}];
const Benefits = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-[13px] font-semibold uppercase tracking-wide text-[#6A6D75]">Why 리뷰드?</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br aria-hidden={true} className="sm:hidden" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mt-3 text-balance break-keep font-[family-name:var(--font-nanum-square-neo)] text-[30px] font-extrabold leading-[1.35] tracking-[-1px] text-[#121212] sm:text-[36px] sm:tracking-[-0.84px] lg:text-[44px] lg:tracking-[-1.26px]">관리된 리뷰가 비로소 {t1}AI에 <span className="font-black text-[#7A33FF]">{"'\uAC80\uC0C9\uB418\uB294 \uC790\uC0B0'"}</span>이 됩니다.</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto flex max-w-[680px] flex-col items-center text-center">{t0}{t2}<p className="mt-4 break-keep text-[17px] leading-relaxed text-[#374151] sm:text-[16px]">리뷰드에 병원을 등록하고 병원의 <br aria-hidden={true} className="sm:hidden" />AI 검색 가시성을 높여보세요.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section id="benefits" className="w-full bg-white py-16 lg:py-20"><div className="mx-auto max-w-[1140px] px-5 lg:px-0">{t3}<ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-14 lg:grid-cols-4">{CARDS.map(_temp)}</ul></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Benefits;
function _temp(card) {
  return <li key={card.title} className="flex flex-col items-center gap-7 rounded-[12px] border border-[#E5E7EB] bg-white px-6 py-8 text-center shadow-[0_4px_24px_rgba(16,20,62,0.06)] transition-shadow duration-300 hover:shadow-[0_8px_32px_rgba(107,0,215,0.10)]"><span className="flex h-[58px] items-center justify-center"><img src={card.icon} alt={card.iconAlt} width={card.iconWidth} height={card.iconHeight} loading="lazy" className="h-[58px] w-auto" /></span><div className="flex flex-col gap-2"><h3 className="break-keep text-[20px] font-bold tracking-[-0.36px] text-[#121212]">{card.title}</h3><p className="text-balance break-keep text-[16px] leading-[1.4] text-[#374151] lg:text-[15px]">{card.desc}</p></div></li>;
}